// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EiXFX","inner":"Footer_inner__3YRpc"};